import axios from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions'
import cookies from 'js-cookie'
import Debug from '../debug/index'
import { cookieOptions } from '@/constants/auth'
import { getCurrentQuery } from '@/utils/index'
import { navigatorLang } from '@/utils/lang';
import { nanoid } from "nanoid";
const debug = new Debug()
import store from '@/pages/H5/Cloud/store'

axios.defaults.withCredentials = false

let redirectCallback = null

const request = axios.create({
    timeout: 15000,
    adapter: cacheAdapterEnhancer(axios.defaults.adapter, {
        enabledByDefault: false,
        cacheFlag: 'useCache',
    }),
})

const getToken = showtype => {
    const isSDK = showtype == 'sdk'
    const isKP = showtype == 'kp'
    if (isSDK === true) {
        return window?.parent?.sdk_userInfo?.token;
    } else if (isKP === true) {
        return store.state.userInfo.token;
    }
    return cookies.get('token');
}

const getUserId = showtype => {
    const isSDK = showtype == 'sdk'
    const isKP = showtype == 'kp'
    if (isSDK === true) {
        return window?.parent?.sdk_userInfo?.userId;
    } else if (isKP === true) {
        return store.state.userInfo.userId;
    }
    return cookies.get('userId');
}

const getDeviceId = showtype => {
    const isSDK = showtype == 'sdk'
    const isKP = showtype == 'kp'
    if (isSDK === true) {
        return window?.parent?.sdk_userInfo?.deviceId;
    } else if (isKP === true) {
        return store.state.userInfo.deviceId;
    }
    return cookies.get('deviceId');
}

const getSpaceId = showtype => {
    const isSDK = showtype == 'sdk'
    const isKP = showtype == 'kp'
    if (isSDK === true) {
        return window?.parent?.sdk_userInfo?.spaceId;
    } else if (isKP === true) {
        return store.state.userInfo.spaceId;
    }
    return cookies.get('spaceId');
}

request.interceptors.request.use(
    config => {
        const isReplaceAllHeader = config.headers['is-replace-all']
        config.headers['accept-language'] = localStorage.getItem("tci18nLocale") || navigatorLang[navigator.language] || 'zh-cn';
        if (!isReplaceAllHeader) {
            const { showtype = '' } = getCurrentQuery() || {}
            const isSDK = showtype == 'sdk'
            const token = getToken(showtype);
            // debug.log(`token = ${token}`)
            const userId = getUserId(showtype);
            // debug.log(`userId = ${userId}`)
            const deviceId = getDeviceId(showtype);
            // debug.log(`deviceId = ${deviceId}`)
            const spaceId = getSpaceId(showtype);
            // debug.log(`spaceId = ${spaceId}`)
            const memberUniqueId = cookies.get('memberUniqueId') || ''
            const memberId = cookies.get('memberId') || memberUniqueId
            if (token && userId && deviceId && spaceId) {
                config.headers['token'] = token
                config.headers['userId'] = userId
                config.headers['deviceId'] = deviceId
                config.headers['spaceId'] = spaceId
                config.headers['deviceType'] = '3'
                if (config.url.indexOf('/app/client/') === -1) {
                    config.headers['x-toca-context'] = encodeURI(
                        JSON.stringify({
                            userId,
                            spaceId,
                            appId: 'com.ly.master',
                            deviceId,
                            deviceType: '3',
                            memberId: memberId
                        })
                    )
                } else {
                    config.headers['x-toca-context'] = encodeURI(
                        JSON.stringify({
                            clientVersion: '',
                            userId,
                            spaceId,
                            appId: 'com.ly.master',
                            deviceId,
                            deviceType: '3',
                            memberId: memberId
                        })
                    )
                }
            }

        }
        if (isReplaceAllHeader == true) {
            delete config.headers['is-replace-all']
        }
        return config
    },
    err => Promise.reject(err)
)

request.interceptors.response.use(
    resp => {
        return resp.data
    },
    err => {
        if (err.response && err.response.status === 401) {
            if (redirectCallback) {
                const callback = redirectCallback
                redirectCallback = null
                cookieOptions.map(item => {
                    cookies.remove('userId', item)
                    cookies.remove('token', item)
                    cookies.remove('spaceId', item)
                })
                callback()
                return
            }
        }
        if (err.response && err.response.data) {
            return err.response.data
        }
        throw new Error(err.message)
    }
)

export const setRedirectCallback = callback => {
    redirectCallback = callback
}

export const get = options => {
    return request({
        method: 'GET',
        ...options,
    })
}

export const post = options => {
    return request({
        method: 'POST',
        ...options,
    })
}

export const delet = options => {
    return request({
        method: 'DELETE',
        ...options,
    })
}

export const put = options => {
    return request({
        method: 'PUT',
        ...options,
    })
}
